<svelte:options tag="webster-footer" />

<script>
	import { onMount } from 'svelte';
	import '../src/websterfooter.css';
	export let base = '';
	const fullyear = new Date().getFullYear();
</script>

<link rel="stylesheet" type="text/css" href="{base}/build/footer3/websterfooter.dist.css">

<footer id="footer" role="contentinfo" class="chasTest footer wb-ocd-component">
	<div class="sitefooter-outer">
		<div class="sitefooter-bottom">
			<div class="sitefooter-ehl">
				<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 11.9 13.24">
				<!-- Generator: Adobe Illustrator 29.4.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 152)  -->
				<defs>
					<style>
					.st0 {
						fill: none;
					}
				
					.st1 {
						clip-path: url(#clippath-1);
					}
				
					.st2 {
						clip-path: url(#clippath-3);
					}
				
					.st3 {
						clip-path: url(#clippath-4);
					}
				
					.st4 {
						clip-path: url(#clippath-2);
					}
				
					.st5 {
						fill: #fff;
					}
				
					.st6 {
						clip-path: url(#clippath);
					}
					</style>
					<clipPath id="clippath">
					<rect class="st0" x="0" y="0" width="11.9" height="13.24"/>
					</clipPath>
					<clipPath id="clippath-1">
					<rect class="st0" x="0" y="0" width="11.9" height="13.24"/>
					</clipPath>
					<clipPath id="clippath-2">
					<rect class="st0" x="0" y="0" width="11.9" height="13.24"/>
					</clipPath>
					<clipPath id="clippath-3">
					<rect class="st0" x="0" y="0" width="11.9" height="13.24"/>
					</clipPath>
					<clipPath id="clippath-4">
					<rect class="st0" x="0" y="0" width="11.9" height="13.24"/>
					</clipPath>
				</defs>
				<path class="st5" d="M2.05,3.51l3.94-2.1,3.94,2.1v4.04H2.05V3.51ZM5.99,0L0,3.09v1.19h.79v4.38h10.34v-4.38h.78v-1.15L5.99,0Z"/>
				<rect class="st5" x="3.91" y="3.62" width="4.12" height="1.08"/>
				<rect class="st5" x="3.91" y="5.49" width="4.12" height="1.08"/>
				<polygon class="st5" points=".61 11.02 .61 13.24 2.01 13.24 2.01 12.83 1.05 12.83 1.05 11.02 .61 11.02"/>
				<polygon class="st5" points="2.25 11.02 2.25 13.24 3.76 13.24 3.76 12.83 2.69 12.83 2.69 12.29 3.65 12.29 3.65 11.91 2.69 11.91 2.69 11.43 3.73 11.43 3.73 11.02 2.25 11.02"/>
				<polygon class="st5" points="5.31 11.02 5.31 12.51 5.31 12.51 4.48 11.02 4.05 11.02 4.05 13.24 4.46 13.24 4.46 11.75 4.46 11.75 5.29 13.24 5.72 13.24 5.72 11.02 5.31 11.02"/>
				<g class="st6">
					<path class="st5" d="M6.96,11.02h-.85v2.22h.85c.15,0,.28-.03.39-.09.11-.06.2-.14.28-.24.08-.1.13-.22.17-.35.04-.14.06-.29.06-.45,0-.19-.02-.35-.07-.48-.05-.14-.11-.25-.19-.34-.08-.09-.18-.16-.29-.21-.11-.05-.23-.07-.36-.07M6.54,12.83v-1.4h.31c.11,0,.2.02.27.05.07.03.13.08.18.15.04.06.08.14.1.23.02.09.03.19.03.3,0,.12-.01.23-.04.31-.03.08-.07.15-.11.21l-.16.11c-.06.02-.12.03-.18.03h-.39Z"/>
				</g>
				<polygon class="st5" points="8.16 11.02 8.16 13.24 9.66 13.24 9.66 12.83 8.59 12.83 8.59 12.29 9.55 12.29 9.55 11.91 8.59 11.91 8.59 11.43 9.64 11.43 9.64 11.02 8.16 11.02"/>
				<g class="st1">
					<path class="st5" d="M11.02,11.02h-1.07v2.22h.44v-.87h.44c.11,0,.19.03.24.08.05.05.08.14.09.25.01.09.02.18.02.28,0,.1.02.18.04.25h.44l-.05-.11-.02-.14v-.15s-.02-.12-.02-.12l-.02-.17-.05-.15-.09-.12-.13-.08h0c.11-.06.19-.13.24-.22.05-.1.07-.21.07-.34,0-.09-.01-.17-.04-.24-.03-.07-.06-.14-.12-.19-.05-.06-.11-.1-.18-.13-.07-.03-.15-.05-.24-.05M10.39,12.03v-.63h.48c.1,0,.17.02.22.07.05.05.07.13.07.24s-.02.19-.07.24c-.05.05-.12.08-.22.08h-.48Z"/>
				</g>
				<polygon class="st5" points=".52 9.55 .52 10.67 1.22 10.67 1.22 10.5 .69 10.5 .69 10.17 1.17 10.17 1.17 10.01 .69 10.01 .69 9.72 1.21 9.72 1.21 9.55 .52 9.55"/>
				<g class="st4">
					<path class="st5" d="M1.77,9.53c-.07,0-.14.02-.19.05l-.14.12c-.04.05-.07.12-.09.19-.02.07-.03.14-.03.22s0,.16.03.23c.02.07.05.13.09.18l.14.13c.06.03.12.05.19.05l.11-.02.11-.05.14.14.08-.11-.12-.12.06-.09.04-.11.02-.12v-.12c0-.08,0-.15-.02-.22-.02-.07-.05-.13-.09-.19l-.14-.12c-.06-.03-.12-.05-.19-.05M1.77,10.53l-.13-.04-.09-.1-.05-.14-.02-.16.02-.16.05-.14.09-.1.13-.04.13.04.09.1.05.14.02.16-.02.16-.06.14-.12-.12-.08.11.1.1-.05.02h-.05Z"/>
					<path class="st5" d="M3.16,9.55h-.17v.76s-.03.1-.03.1l-.07.08-.13.03-.13-.03-.07-.08-.03-.1v-.11s0-.65,0-.65h-.17v.71c0,.07,0,.13.03.19l.08.13.12.08.16.03.16-.03.12-.08.08-.13c.02-.05.03-.12.03-.19v-.71Z"/>
				</g>
				<path class="st5" d="M3.69,9.75h0l.14.48h-.29l.14-.48ZM3.61,9.55l-.37,1.11h.17l.09-.3h.38l.09.3h.18l-.37-1.11h-.18Z"/>
				<polygon class="st5" points="4.24 9.55 4.24 10.67 4.9 10.67 4.9 10.5 4.41 10.5 4.41 9.55 4.24 9.55"/>
				<polygon class="st5" points="6.34 9.55 6.34 10 5.91 10 5.91 9.55 5.75 9.55 5.75 10.67 5.91 10.67 5.91 10.16 6.34 10.16 6.34 10.67 6.5 10.67 6.5 9.55 6.34 9.55"/>
				<g class="st2">
					<path class="st5" d="M7.1,9.53c-.07,0-.13.02-.19.05l-.14.12c-.04.05-.07.12-.09.19-.02.07-.03.14-.03.22s.01.16.03.23c.02.07.05.13.09.18l.14.13c.06.03.12.05.19.05s.13-.02.19-.05l.14-.13c.04-.05.07-.11.09-.18.02-.07.03-.15.03-.23s-.01-.15-.03-.22c-.02-.07-.05-.13-.09-.19l-.14-.12c-.06-.03-.12-.05-.19-.05M7.1,10.53l-.13-.04-.09-.1-.05-.14-.02-.16.02-.16.05-.14.09-.1.13-.04.13.04.09.1.05.14.02.16-.02.16-.05.14-.09.1-.13.04Z"/>
					<path class="st5" d="M8.45,9.55h-.16v.76s-.03.1-.03.1l-.07.08-.12.03-.12-.03-.07-.08-.03-.1v-.11s0-.65,0-.65h-.16v.71c0,.07.01.13.03.19l.08.13.12.08.16.03.16-.03.12-.08.08-.13c.02-.05.03-.12.03-.19v-.71Z"/>
					<path class="st5" d="M8.96,9.53l-.12.02-.11.06-.08.1-.03.15v.09s.04.08.04.08l.06.07.1.05c.07.02.12.04.16.05l.12.04.05.04.02.09v.06s-.04.05-.04.05l-.06.04-.09.02h-.09s-.08-.06-.08-.06l-.05-.07-.02-.11h-.16c0,.07.01.13.03.18l.08.12.12.07.15.02.14-.02.12-.06.08-.11s.03-.1.03-.16v-.09s-.05-.08-.05-.08l-.06-.07-.08-.05-.06-.02-.09-.03-.08-.03h-.04s-.08-.06-.08-.06l-.03-.09.02-.07.04-.04.06-.02h.06s.14.04.14.04c.04.03.06.08.06.15h.16l-.03-.15-.08-.11-.11-.07-.14-.02Z"/>
				</g>
				<rect class="st5" x="9.49" y="9.55" width=".16" height="1.11"/>
				<polygon class="st5" points="10.44 9.55 10.44 10.37 10.44 10.37 10.02 9.55 9.84 9.55 9.84 10.67 10 10.67 10 9.85 10 9.85 10.43 10.67 10.6 10.67 10.6 9.55 10.44 9.55"/>
				<g class="st3">
					<path class="st5" d="M11.2,9.53c-.07,0-.13.02-.19.05l-.14.13c-.04.05-.07.11-.09.18-.02.07-.03.15-.03.22s.01.15.03.23c.02.07.05.13.09.19l.14.12c.06.03.12.05.19.05l.15-.03.13-.12.02.13h.11v-.59h-.4v.15h.25l-.02.13-.05.1-.08.06-.11.02-.13-.04-.09-.1-.05-.14-.02-.15.02-.16.05-.14.09-.1.13-.04h.09s.07.06.07.06l.06.07.03.1h.16c0-.06-.02-.12-.04-.17l-.09-.12-.12-.07-.15-.02Z"/>
				</g>
				</svg>
			</div>
			<div class="sitefooter-bottomcontainer">
				<div class="sitefooter-copyright">
					<p>
						Webster Bank, N.A., Member FDIC. Webster, Webster Bank, Webster Investments, the Webster Bank logo, and the W symbol are trademarks of Webster Financial Corporation and registered in the U.S. Patent and Trademark Office.
						&copy;&nbsp;<span id="footer_copyright_year">{fullyear}</span> Webster Financial Corporation. All rights reserved.
					</p>
				</div>
			</div>
		</div>
	</div>
</footer>

<style>

</style>
